/**
 * An abstract class with no instance methods. Used globally to generate uuids by any
 * consumer. Application must call SetGenerator before use.
 */
export class UuidGenerator {
    /**
     * @param {function} syncImpl - A syncronous function that returns a UUID.
     */
    static SetGenerator(syncImpl) {
        this.syncUuidFunc = syncImpl;
    }
    /**
     * Generates a UUID string asyncronously.
     */
    static GenerateUuid() {
        return this.syncUuidFunc();
    }
}
